<div class="flex flex-column justify-content-between gap-4">
  <div class="flex flex-column">
    <ng-container
      *ngIf="args.command === 'sendCommand' && args.schema === 'industrial-gateway-v1'">
      <app-synoptics-industrial-gateway-command-form
        (validFormChange)="industrialFormValidity = $event; checkChanges()"
        [(deviceGateway)]="paramValues['deviceGateway']"
        [(sensorName)]="paramValues['sensorName']"
        [(sensorValue)]="paramValues['sensorValue']"
        [deviceUuid]="args.deviceUuid"
        [mode]="'sendCommand'"
      >
      </app-synoptics-industrial-gateway-command-form>
    </ng-container>
    <ng-container
      *ngIf="args.command !== 'sendCommand' && args.schema !== 'industrial-gateway-v1'">
      <div *ngFor="let keyValue of params | keyvalue" class="flex flex-column">
        <label class="mb-2">{{ 'misc.paramLabel' | transloco: {paramName: keyValue.key} }}</label>
        <app-generic-command-input
          (valueChange)="updateModel(keyValue.key, $event)"
          [validators]="keyValue.value['validators']"
          [value]="paramValues[keyValue.key]"
        ></app-generic-command-input>
      </div>
    </ng-container>
  </div>
  <div class="flex justify-content-between">
    <button
      (click)="ref.close(null)"
      [label]="'common.cancel' | transloco"
      class="p-button-danger"
      icon="pi pi-times"
      pButton
    ></button>
    <button
      (click)="ref.close(paramValues)"
      [disabled]="(paramValues | anyNull ) || !(isFormValid$ | async) || !(industrialFormValidity ?? true)"
      [label]="'misc.sendCommand' | transloco"
      icon="pi pi-send"
      iconPos="right"
      pButton
    ></button>
  </div>
</div>
